export function preparePresetColor(colorCode: string | undefined): string | undefined {
  if (colorCode) {
    const color = getColorFromCode(colorCode)?.toUpperCase();
    return color !== '#FFFFFF' ? color : undefined;
  }
  return undefined;
}

export function getColorFromCode(code: string | undefined): string | undefined {
  // Idempotent: the stored value may already carry a leading '#' — the scene engine
  // writes "#RRGGBB" to input_text.<room>_lights_color, while colour presets are
  // stored bare. Without the strip an already-prefixed value became "##RRGGBB",
  // which no swatch or preset comparison matches.
  return !!code ? `#${code.replace(/#/g, '')}`.toUpperCase() : undefined;
}

// NOTE: this MUST keep stripping the '#'. The value it produces is written to
// input_text.<room>_lights_color, and vOS's `lights_cycle_custom_colors` (the
// double-tap colour cycle) compares that value as an opaque string against the
// bare preset list in input_text.custom_light_color_01..04. Writing "#RRGGBB"
// made the comparison never match, so cycling restarted at the first preset
// instead of advancing. vOS's lights_turn_on now parses either format, so the
// '#' buys nothing here and costs the cycle.
export function getCodeFromColor(code: string): string {
  return code.replace(/#/g, '').toUpperCase();
}
